import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/icon/floatrate/edit.png'
import _imports_1 from '@/assets/image/icon/upload_add.png'


const _withScopeId = n => (_pushScopeId("data-v-4b9cdf4c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "shop-addition-group" }
const _hoisted_2 = { class: "title mb_5" }
const _hoisted_3 = { class: "flex-ter title-h1" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "greenDot" }, null, -1))
const _hoisted_5 = { class: "flex-wrap mb_30" }
const _hoisted_6 = { class: "flex title" }
const _hoisted_7 = { class: "fx-1 line--2 upBlock flex-ter" }
const _hoisted_8 = {
  key: 0,
  class: "all-calc-tag"
}
const _hoisted_9 = { class: "fx-1" }
const _hoisted_10 = { class: "add-data downBlock" }
const _hoisted_11 = { class: "line--2" }
const _hoisted_12 = {
  key: 0,
  class: "actions"
}
const _hoisted_13 = ["onClick"]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_16 = [
  _hoisted_15
]

import { getCustomerAdditionTemplateListApi, updateCustomerAdditionTemplateStatusApi, getAdditionTemplateDetailApi } from '@/apis/addition'
import { t } from '@/plugins/i18n'
import { ref, nextTick, onMounted, watch } from 'vue'
import { useRoute } from 'vue-router'
import CreateAdditionTemplate from '@/components/additional/CreateAdditionTemplate.vue'
import { getShippingConfigTypeApi, getAllIncludeCheckCustomerApi } from '@/apis/setup'
import { request } from '@/config/request/interceptors'
import { CategoryAdaptInfo } from '@/service/settlement'

export default /*#__PURE__*/_defineComponent({
  props: ['warehouseCode', 'countryCode'],
  setup(__props) {

const props = __props
const list: any = ref([])
const route = useRoute()
const isJumpSetPriceTemplate = ref(false)
const priceTypeList = ref<CategoryAdaptInfo[]>()
onMounted(async () => {
  init()
  const result = await getAllIncludeCheckCustomerApi()
  // 一价全包 没有设置一口价附加项套餐，跳转弹窗
  if (route.query.name === 'ShopAddition' && route.query.isShowAdditionDrawer && result.data.supportAllInclude) {
    templateVisible.value = true
    isJumpSetPriceTemplate.value = true
    history.replaceState(null, '', route.path)
  }
  const { data } = await request.settlement.allInclude.categoryAdaptInfo()
  priceTypeList.value = data
})

// 接收props的defineProps


const init = () => {
  getCustomerAdditionTemplateListApi({
    pageNum: 1,
    pageSize: 1000,
    warehouseCode: props.warehouseCode
  }).then((res) => {
    list.value = res.data.records
  })
}
// 监听商品切换，重新请求
watch(() => props.warehouseCode, (val) => {
  init()
})
const STableRef = ref()
const form = ref({
  templateName: '',
  templateType: '',
  templateStatus: ''
})
const pageData = ref({
  page: 1,
  limit: 1000
})
const filterData = ref({})
const search = () => {
  pageData.value = {
    page: 1,
    limit: 1000
  }
  filterData.value = form.value
  nextTick(() => {
    STableRef.value && STableRef.value.getData()
  })
}
const clear = () => {
  form.value = {
    templateName: '',
    templateType: '',
    templateStatus: ''
  }
  search()
}
const templateVisible = ref(false)
const additionTemplateId = ref('')
const proxy: any = ref({})
const openCreateAdditionDialog = (item?: any) => {
  isJumpSetPriceTemplate.value = false
  if (item?.additionTemplateId) {
    additionTemplateId.value = item?.additionTemplateId
    item.loading = true
    getAdditionTemplateDetailApi({
      additionTemplateId: item?.additionTemplateId
    }).then((res: any) => {
      if (res.success) {
        proxy.value = res?.data || {}
        templateVisible.value = true
      }
    }).finally(() => {
      item.loading = false
    })
  } else {
    proxy.value = {}
    templateVisible.value = true
  }
}
const refreshTable = () => {
  init()
}
const changeStatus = (row: any) => {
  updateCustomerAdditionTemplateStatusApi({
    additionTemplateId: row.additionTemplateId,
    templateStatus: row.templateStatus === 1 ? 2 : 1
  }).then((res: any) => {
    if (res.success) {
      init()
    }
  })
}

return (_ctx: any,_cache: any) => {
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createTextVNode(" " + _toDisplayString(_unref(t)('附加项组合')), 1)
        ])
      ]),
      _createVNode(_component_el_scrollbar, { height: "400px" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "add-cfg rel",
                key: index
              }, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    (item.supportAllInclude === 1)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_unref(t)('一价全包')) + "-" + _toDisplayString(priceTypeList.value?.find(v =>
                v.categoryCode === item.categoryCode)?.categoryNameJp), 1))
                      : _createCommentVNode("", true),
                    _createTextVNode(" " + _toDisplayString(_unref(t)('组合名称')) + "： ", 1),
                    _createElementVNode("span", _hoisted_9, _toDisplayString(item.templateName ?? '-'), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, _toDisplayString(item.additionName ?? '-'), 1)
                ]),
                (item.templateStatus !== 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                      _createVNode(_component_el_switch, {
                        "model-value": item.templateStatus === 1,
                        onClick: ($event: any) => (changeStatus(item))
                      }, null, 8, ["model-value", "onClick"]),
                      (item.isDefault !== 1)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: "actions-open",
                            onClick: ($event: any) => (openCreateAdditionDialog(item))
                          }, [
                            _hoisted_14,
                            _createTextVNode(_toDisplayString(_unref(t)('打开全部')), 1)
                          ], 8, _hoisted_13))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ]))
            }), 128)),
            _createElementVNode("div", {
              class: "add-cfg-btn flex-center btn",
              onClick: openCreateAdditionDialog
            }, _hoisted_16)
          ])
        ]),
        _: 1
      })
    ]),
    _createVNode(CreateAdditionTemplate, {
      countryCode: props.countryCode,
      warehouseCode: props.warehouseCode,
      visible: templateVisible.value,
      "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((templateVisible).value = $event)),
      title: _unref(t)(!additionTemplateId.value ? '创建附加项组合' : '修改附加项组合'),
      proxy: proxy.value,
      onSubmit: _cache[1] || (_cache[1] = ($event: any) => (refreshTable())),
      isJumpSetPriceTemplate: isJumpSetPriceTemplate.value
    }, null, 8, ["countryCode", "warehouseCode", "visible", "title", "proxy", "isJumpSetPriceTemplate"])
  ], 64))
}
}

})